import { SwiperOptions } from "swiper/types";

export const quoteSwiperOptions: SwiperOptions = {
  spaceBetween: 30,
  centeredSlides: true,
  pagination: {
    enabled: true,
    clickable: true,
  },
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },

  navigation: true,
  injectStyles: [
    `
   .swiper {
    overflow: visible;     

    .swiper-pagination {
        position: relative;
        margin-top: 2rem;

        .swiper-pagination-bullet {
            width: 0.75rem;
            height: 0.75rem;

            &.swiper-pagination-bullet-active {
                background: $primary;
            }
        }
    }

    .swiper-button-next,
      .swiper-button-prev {
        color: white;
      }

      .swiper-button-prev {
        left: $spacer;
      }

      .swiper-button-next {
        right: $spacer;
      }

    @include media-breakpoint-up(lg) {

    .swiper-button-prev {
        left: 16%;
    }

    .swiper-button-next {
        right: 16%;
    }

   }
    `,
  ],
  breakpoints: {
    992: {
      slidesPerView: 2.5,
    },
  },
};
